// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3f-0";
export var eligibilityCardNotEligible = "_3f-1";